import { NotificationChannel, NotificationStatus } from "Data";
import { toTitleCase } from "Utils";

const ChannelOptions = [
    { label: "Email", value: NotificationChannel.EMAIL },
    { label: "SMS", value: NotificationChannel.SMS },
    { label: "Push", value: NotificationChannel.PUSH },
    { label: "Whatsapp", value: NotificationChannel.WHATSAPP },
];

const StatusOptions = Object.keys(NotificationStatus).map((key) => ({
    label: toTitleCase(key),
    value: key,
}));

export { ChannelOptions, StatusOptions };
